export const showStart = (index: number) => index === -1;
